import { defineComponent } from 'vue';
import ModalOverlay from '~/components/common/ModalOverlay.vue';
import DisclosureModal from '~/components/members-area/DisclosureModal.vue';
import { PaymentOption } from '~/pages/members/card.vue';
export default defineComponent({
  name: 'PaymentOptionEducation',
  components: {
    ModalOverlay,
    DisclosureModal
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    mid: {
      type: Number,
      required: false
    },
    formFilled: {
      type: Boolean,
      required: false
    }
  },
  emits: ['update:open', 'set-payment-option'],
  data() {
    return {
      stage: 0,
      disclosureOption: undefined
    };
  },
  computed: {
    screenName() {
      let name;
      switch (this.stage) {
        case 0:
          name = 'Disclosure';
          break;
        case 1:
          name = 'Modal 1';
          break;
        case 2:
          name = 'Modal 2';
          break;
      }
      return name;
    }
  },
  watch: {
    open: 'trackScreenViewed',
    stage: 'trackScreenViewed'
  },
  methods: {
    trackScreenViewed() {
      if (this.open) {
        this.$analyticsHub.track(`14 Day Payment ${this.screenName} Viewed`, {
          member_id: this.mid
        });
      }
    },
    trackScreenSelected(payment_option) {
      if (this.open) {
        this.$analyticsHub.track(`14 Day Payment ${this.screenName} Selected`, {
          member_id: this.mid,
          payment_option
        });
      }
    },
    close() {
      this.$emit('update:open', false);
      this.stage = 0;
      this.disclosureOption = undefined;
    },
    backToDisclosure() {
      this.stage = 0;
      this.disclosureOption = undefined;
    },
    reviewDisclosureOption() {
      if (!this.disclosureOption) return;
      if (this.disclosureOption === PaymentOption.NEXT_DAY_ACH) {
        this.confirmNextDayPaymentOption();
      } else {
        this.trackScreenSelected(this.disclosureOption);
        this.stage = 1;
      }
    },
    completeModalStage1() {
      this.trackScreenSelected(this.disclosureOption);
      this.stage = 2;
    },
    confirmNextDayPaymentOption() {
      this.trackScreenSelected(PaymentOption.NEXT_DAY_ACH);
      this.$emit('set-payment-option', PaymentOption.NEXT_DAY_ACH);
      this.close();
    },
    confirm14DayPaymentOption() {
      this.trackScreenSelected(PaymentOption.FOURTEEN_DAYS_ACH);
      this.$emit('set-payment-option', PaymentOption.FOURTEEN_DAYS_ACH);
      this.close();
    }
  }
});